import { InputBalloon as ReolinkInputBalloon } from '@reolink-deps/reolink-web_components.web';
import { InputBalloon as CamovueInputBalloon } from '@camovue-deps/reolink-web_components.web';
import type { IInputBalloonProps as IReolinkInputBalloonProps } from '@reolink-deps/reolink-web_components.web';
import type { IInputBalloonProps as ICamovueInputBalloonProps } from '@camovue-deps/reolink-web_components.web';
import type { IInputBalloonFetchProps as IReolinkInputBalloonFetchProps } from '@reolink-deps/reolink-web_components.web';
import type { IInputBalloonFetchProps as ICamovueInputBalloonFetchProps } from '@camovue-deps/reolink-web_components.web';

const InputBalloon = __MERCHANT__ === 'reolink' ? ReolinkInputBalloon : CamovueInputBalloon;

export type IInputBalloonProps = IReolinkInputBalloonProps | ICamovueInputBalloonProps;
export type IInputBalloonFetchProps = IReolinkInputBalloonFetchProps | ICamovueInputBalloonFetchProps;
export default InputBalloon;
